export const CLUSTERING_CONFIG = {
  MIN_WORD_LENGTH: 3,
  MIN_NGRAM_FREQUENCY: 2,
  MIN_CLUSTER_SIZE: 3,
  MIN_TERM_LENGTH: 4,
  NGRAM_SIZES: [1, 2, 3] as const,
  MAX_CLUSTERS: null,
  MIN_KEYWORDS_FOR_CLUSTERING: 3,
} as const;